import { getTaskByName } from '../services/Dig/TaskManager/TaskManagerServices';
import Message from './Message/Message';

export const GetTablenameFromTask = async (
  table_name: string
): Promise<string> => {
  let the_table_name = '';
  await getTaskByName(table_name)
    .then((el) => {
      the_table_name = '';
      if (el.data.length > 0) {
        the_table_name = el.data[0].source_table;
      }
    })
    .catch((er) => {
      Message.error("Can't acces business logic parameter");
      if (er.response) {
        Message.error(
          er.response.data +
            '\n' +
            er.response.status +
            '\n' +
            er.response.headers
        );
      } else if (er.request) {
        Message.error(er.request);
      } else {
        Message.error('Error: ' + er.message);
      }
      Message.error(er.config);
    });
  return the_table_name;
};
